import { PNL_LINES } from '../constants/wfReportConfig';
const round = n => Math.sign(n) * Math.round((Math.abs(n) + Number.EPSILON) * 100) / 100;
export function worksheetPnl(lines = {}) {
  const normalized = Object.fromEntries(PNL_LINES.map(l => [l.key, Number(lines[l.key]) || 0]));
  const sum = section => round(PNL_LINES.filter(l => l.section === section).reduce((n, l) => n + normalized[l.key], 0));
  const total_income = sum('income'), total_cogs = sum('cogs'), total_fixed = sum('fixed');
  const gross_profit = round(total_income - total_cogs), net_profit = round(gross_profit - total_fixed);
  const ratio = n => total_income > 0 ? round(n / total_income * 100) : null;
  return { lines: normalized, total_income, total_cogs, total_fixed, gross_profit, net_profit,
    gross_margin_pct: ratio(gross_profit), net_profit_pct: ratio(net_profit), marketing_pct: ratio(normalized.fx_marketing), wages_pct: ratio(normalized.cogs_wages) };
}
export function worksheetYear(data, drafts) {
  const months = data.months.map(m => drafts[m.month] ? { ...m, pnl: worksheetPnl({ ...m.pnl?.lines, ...drafts[m.month] }) } : m);
  const sums = {};
  months.forEach(m => PNL_LINES.forEach(l => { sums[l.key] = (sums[l.key] || 0) + (m.pnl?.lines[l.key] || 0); }));
  return { ...data, months, ytd: worksheetPnl(sums) };
}
